export  const NEWSES_REQUEST_START = 'NEWSES_REQUEST_START';
export  const NEWSES_REQUEST_SUCCESS_EN = 'NEWSES_REQUEST_SUCCESS_EN';
export  const NEWSES_REQUEST_SUCCESS_RU = 'NEWSES_REQUEST_SUCCESS_RU';
export  const NEWSES_REQUEST_SUCCESS_ARM = 'NEWSES_REQUEST_SUCCESS_ARM';
export  const NEWSES_REQUEST_FAIL_EN = 'NEWSES_REQUEST_FAIL_EN';
export  const NEWSES_REQUEST_FAIL_RU = 'NEWSES_REQUEST_FAIL_RU';
export  const NEWSES_REQUEST_FAIL_ARM = 'NEWSES_REQUEST_FAIL_ARM';
export const LOAD_MORE_NEWSES = 'LOAD_MORE_NEWSES'
